const VISORIA_BACKEND_URL =
  process.env.REACT_APP_VISORIA_BACKEND_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  "";

async function getJson(path, params, signal) {
  const url = `${VISORIA_BACKEND_URL}/api/visoria${path}?${new URLSearchParams(params)}`;
  const response = await fetch(url, {
    headers: { Accept: "application/json" },
    signal,
  });
  if (!response.ok) {
    const error = new Error(`HTTP ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return response.json();
}

const nintendoSearchService = {
  /** Нечёткий поиск игр с ценой региона, рублями и картами региона. */
  search: (region, q, signal) =>
    getJson("/nintendo/search", { region, q }, signal),

  /** Варианты игр, чтобы потратить остаток баланса eShop в ноль. */
  spend: (region, amount, dlc, signal) =>
    getJson(
      "/nintendo/spend",
      { region, amount: String(amount), dlc: dlc ? "1" : "0" },
      signal,
    ),

  /** Игра со страницы /nintendo/igry/<slug> и её цена в регионе — для покупки по ссылке ?buy=. */
  offer: (slug, region, signal) =>
    getJson("/nintendo/offer", { slug, region: region || "" }, signal),

  /** Цена игры в eShop прямо сейчас (каталог обновляется раз в сутки). */
  livePrice: (region, nsuid, signal) =>
    getJson("/nintendo/price", { region, nsuid }, signal),
};

export default nintendoSearchService;
